import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=7b00352e&scoped=true&"
import script from "./BankAccount.vue?vue&type=script&lang=ts&"
export * from "./BankAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccount.vue?vue&type=style&index=0&id=7b00352e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b00352e",
  null
  
)

export default component.exports